class CookieAccept {
	constructor(container) {
		if (!container) return;
		this.container = container;
		this.cookieAcceptBtn = this.container.querySelector('button.vl-button');
		this.addListener();
	}

	addListener() {
		this.cookieAcceptBtn.addEventListener('click', ()=> {
			this.sendRequest();
		});
	}

	sendRequest() {
		const httpRequest = new XMLHttpRequest();
		httpRequest.onload = () => {
			if (httpRequest.readyState === 4 && httpRequest.status === 200) {
				this.hideCookieBanner();
			}
		};
		httpRequest.open('POST', '/TrackingConsent/Accept');
		httpRequest.send();
	}

	hideCookieBanner() {
		this.container.classList.add('br_cookie-banner--hidden');
	}
}

export default CookieAccept;
